import i18n from '../i18n';

/**
 * Backend artık Türkçe metin yerine SCREAMING_SNAKE_CASE hata kodları döndürüyor
 * (örn. { error: 'NOTE_NOT_FOUND' }). Bu fonksiyon böyle bir kodu kullanıcının
 * diline çevirir. errors.json içinde tanımlı olmayan kodlar için (ör. eski
 * sunucu sürümü, beklenmeyen hata) orijinal mesaj veya genel bir metin döner.
 *
 * @param {Error|{message?: string, payload?: {error?: string, message?: string}}} error
 * @param {object} [options]
 * @param {string} [options.fallback] - errors.json'da karşılığı bulunamazsa gösterilecek metin
 * @returns {string}
 */
export function getApiErrorMessage(error, options = {}) {
  const code = error?.payload?.error || error?.code || error?.message;
  const isKnownCode = typeof code === 'string' && /^[A-Z][A-Z0-9_]*$/.test(code);

  if (isKnownCode) {
    const translated = i18n.t(`errors:${code}`, { defaultValue: '' });
    if (translated) return translated;
  }

  return options.fallback || error?.payload?.message || error?.message || i18n.t('errors:GENERIC_ERROR');
}

export default getApiErrorMessage;
